var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-modal-state"},[_c('div',{staticClass:"app-modal-state__content"},[_vm._t("default")],2),_vm._v(" "),_vm._t("icon")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }